import { convertTemperature, todayOrTomorrow, convertToDayOfWeek } from '../helpers.js';
import { getIcon } from '../icons.js';

const renderUDFD = (forecast) => {
  const udfd = forecast.udfd_basic.data;
    
  udfd.forEach((daily, day) => {
    // Add leading '0' to each day of the forecast (e.g. 1 -> 01, 2 -> 02, etc.)
    day = day.toString().padStart(2, '0');

    document.getElementById(`udfd-high-${day}`).innerHTML = convertTemperature(daily.temperature.max).fahrenheit + '&deg;';
    document.getElementById(`udfd-low-${day}`).innerHTML = convertTemperature(daily.temperature.min).fahrenheit + '&deg;';
    
    if (daily.daytime) {
      if (day === '00') {
        document.getElementById('udfd-daylong-00').innerHTML = todayOrTomorrow(daily.daytime.valid_begin).toUpperCase();
        document.getElementById('udfd-dayshort-00').innerHTML = convertToDayOfWeek(daily.daytime.valid_begin).short.toUpperCase();
        document.getElementById('udfd-pop-00').innerHTML = daily.daytime.precipitation.probability.value + '%';
        document.getElementById('udfd-phrase-00').innerHTML = daily.daytime.weather_code.text;
        document.getElementById('udfd-icon-00').setAttribute('src', getIcon(daily.daytime.weather_code.value));
      } else {
        document.getElementById(`udfd-daylong-${day}`).innerHTML = convertToDayOfWeek(daily.daytime.valid_begin).long.toUpperCase();
        document.getElementById(`udfd-dayshort-${day}`).innerHTML = convertToDayOfWeek(daily.daytime.valid_begin).short.toUpperCase();
        document.getElementById(`udfd-pop-${day}`).innerHTML = daily.daytime.precipitation.probability.value + '%';
        document.getElementById(`udfd-phrase-${day}`).innerHTML = daily.daytime.weather_code.text;
        document.getElementById(`udfd-icon-${day}`).setAttribute('src', getIcon(daily.daytime.weather_code.value));
      }
    }
  });
};

export { renderUDFD };